import { render, staticRenderFns } from "./TeacherCertificat.vue?vue&type=template&id=ee086af8&scoped=true"
import script from "./TeacherCertificat.vue?vue&type=script&lang=js"
export * from "./TeacherCertificat.vue?vue&type=script&lang=js"
import style0 from "./TeacherCertificat.vue?vue&type=style&index=0&id=ee086af8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee086af8",
  null
  
)

export default component.exports